import { render, staticRenderFns } from "./CrearEditarProceso.vue?vue&type=template&id=c458ec7e&scoped=true&"
import script from "./CrearEditarProceso.vue?vue&type=script&lang=js&"
export * from "./CrearEditarProceso.vue?vue&type=script&lang=js&"
import style0 from "./CrearEditarProceso.vue?vue&type=style&index=0&id=c458ec7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c458ec7e",
  null
  
)

export default component.exports